import { eventBus } from "@/shared/thorlabs/shared";
import type { Product } from "@/core/api/graphql/types";
import type { Composer } from "vue-i18n";

export function showPriceRequestDialog(product: Product | undefined) {
  if (product) {
    eventBus.emit("showPriceRequestDialog", { product });
  }
}

export function getAccessoryDisplayName(catalogName: string | undefined, i18n: Composer): string {
  if (!catalogName || (catalogName.match(/-/g) || []).length < 2) {
    return "";
  }

  const withoutDataArea = catalogName.slice(0, catalogName.lastIndexOf("-"));
  const withoutRegion = withoutDataArea.slice(0, withoutDataArea.lastIndexOf("-"));

  // const firstPart = catalogName.replace(/([ -])([A-Z]{2,})-[A-Z]{2,}-[a-z0-9]+$/i, "$1$2");
  const resourceName = withoutRegion.replace(/[-\s]+/g, "_").toLowerCase();
  const key = `shared.checkout.accessory_items.${resourceName}`;

  if (i18n.te(key)) {
    return i18n.t(key);
  }

  return withoutRegion;
}
